export default class TitleFlagManager {
  index: number[] = []
  flags: boolean[] = []
  push(indx: number, flg: boolean) {
    this.index.push(indx)
    this.flags.push(flg)
  }
  isshowing(indx: number) {
    if (this.index.includes(indx)) {
      return this.flags[this.index.indexOf(indx)]
    } else {
      return false
    }
  }
  edit(indx: number, flg: boolean) {
    if (this.index.includes(indx)) {
      this.flags[this.index.indexOf(indx)] = flg
    } else {
      this.push(indx, flg)
    }
  }
}
